import { authTokenInterceptor } from './auth-token.interceptor';
import { AxiosRequestConfig } from 'axios';

export const requestInterceptors: Array<
  (config: AxiosRequestConfig) => Promise<AxiosRequestConfig> | AxiosRequestConfig
> = [authTokenInterceptor];
